module.exports = "/365FarmNet/dist/cfn-vendor-product-id.tpl.6438dc9cc2e18207e8c9e25be33e594c.html";